<template>
	<section class="lost-found-item-container">
		<header class="lost-found-item-header">
			<slot></slot>
		</header>
		<section class="lost-found-item-body">
			<div class="lost-found-item-body-gallery">
				<header>
					<h6>Fotos</h6>
				</header>
				<div class="lost-found-images">
					<img class="lost-found-image" v-bind:src="image" width="222" height="123"
					  alt="Lost Found Gallery" v-for="image in images" v-bind:key="image"
					/>
				</div>
			</div>
			<div class="lost-found-item-comment">
				<header>
					<h6>Comentario</h6>
				</header>
				<p>
					{{comment}}
				</p>
			</div>
			<div class="lost-found-item-actions">
				<button v-if="status === 1" v-bind:disabled="isLoading" v-bind:class="statusButton.class"
				  v-on:click="onStatusChange">
					{{statusButton.text}}
				</button>
			</div>
		</section>
	</section>
</template>

<script>

const STATUS_CHANGE = 'status-change';

function onStatusChange() {
	this.$emit(STATUS_CHANGE, this.id);
}

function statusButton() {
	const status = {
		class: this.status === 1 ? 'delivered' : 'archived',
		text: this.status === 1 ? 'Ya se entregó' : 'Archivar',
	};
	return status;
}

export default {
	name: 'lost-found-item',
	computed: {
		statusButton,
	},
	props: {
		id: {
			type: Number,
			required: true,
		},
		comment: {
			type: String,
			required: true,
		},
		images: {
			type: Array,
			required: true,
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
		status: {
			type: Number,
			required: true,
		},
	},
	methods: {
		onStatusChange,
	},
};
</script>

<style lang="scss" scoped>
.lost-found-item-container {
	border-bottom: 1px solid map-get($colors, default-bg);
	border-left: 1px solid map-get($colors, default-bg);
	display: flex;
	flex-direction: column;
	font-size: 14px;
	margin-left: 19px;

	.lost-found-item-header {
		background-color: white;
		padding: 10px 15px 11px 17px;
	}

	.lost-found-item-body {
		display: flex;
		flex-direction: column;
		padding-bottom: 27px;
		padding-left: 18px;
		padding-right: 20px;
		padding-top: 15px;
		text-align: left;

		.lost-found-item-body-gallery {
			margin-bottom: 16px;
		}

		.lost-found-image {
			margin-right: 16px;
		}

		.lost-found-item-comment {
			p {
				color: map-get($colors, realtime-label);
				font-family: map-get($fonts, regular);
				font-size: 15px;
				text-align: justify;
			}
		}

		header>h6 {
			font-family: map-get($fonts, medium);
			font-size: map-get($sizes, fourteen);
		}
	}

	.lost-found-item-actions {
		button {
			background-color: map-get($colors, default-skyblue);
			box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
			color: white;
			font-family: map-get($fonts, bold);
			font-size: 12px;
			font-weight: bold;
			height: 38px;
			width: 164px;
		}

		.archived {
			background-color: map-get($colors, red-archived);
		}
	}
}
</style>



// WEBPACK FOOTER //
// LostFoundItem.vue?fd2b361e